'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.deviceChange = void 0;
var magic_messages_1 = require("@gig/magic-messages");
function deviceChange(callback) {
    return window.eventBus.subscribe(magic_messages_1.BREAKPOINT_DEVICE_UPDATED, callback, {
        replay: true,
    });
}
exports.deviceChange = deviceChange;
